import { IERC20__factory, IOFTv2__factory } from '@open-blox/interfaces';
import { TOKEN_AVAX, OFT_AVAX } from '@/constants/chains';
import { useSigner } from './useSigner';

export const useOBXContract = (address = TOKEN_AVAX) => {
  const signer = useSigner();
  if (signer) {
    return IERC20__factory.connect(address, signer);
  } else {
    return null;
  }
};

export const useOFTContract = (address = OFT_AVAX) => {
  const signer = useSigner();
  if (signer) {
    return IOFTv2__factory.connect(address, signer);
  } else {
    return null;
  }
};
